import * as React from 'react'
import { connect } from 'react-redux'
import { IDetailPageState } from '../../reducers'
import { Collection } from '../collection/collection'
import { Container } from '@amzn/dvui/dist/Container'
import {
  tabCollectionsSelector,
  ISanitizedCollections,
  showTabCollectionsSelector
} from '../../selectors/collections'


export interface ICollectionProps {
  showTabCollections: boolean,
  collections: ISanitizedCollections
}

export const ConnectedCollectionTabs = ({ collections, showTabCollections }: ICollectionProps) => {
  if (!showTabCollections) return null

  const tabCollections = collections.map((col, idx) =>
    <Collection {...col} key={`collection-${col.index}-${idx}`}/>
  )

  return (
    <Container>
      {tabCollections}
    </Container>
  )
}

const mapStateToProps = (state: IDetailPageState): ICollectionProps => ({
  showTabCollections: showTabCollectionsSelector(state),
  collections: tabCollectionsSelector(state)
})

export const CollectionTabs = connect(mapStateToProps)(ConnectedCollectionTabs)
